import { toast } from 'react-toastify'
import { getMPData, getMPDataWithParams, postMPDataWithoutParams } from 'src/mentor/services'

const LEGAL_OBJECT = {
  signedOn: '2023-08-24 17:14',
  signedAt: '',
  signed: false,

  ageGroups: [],
  allowPreview: true,
  apiParam: '',
  approveAt: {}, //we can use this for approval
  approved: true,
  approvedBy: '', //we can use this for approval
  availableForPlan: true,
  avgDuration: 0,
  colors: null,
  content: '',
  contentList: [],
  countries: [],
  courseType: '',
  coverIcon: '',
  coverIconColor: '',
  coverImage: '',
  coverImageColor: '',
  createdBy: '',
  createdByName: '',
  createdFor: '',
  createdForName: '',
  createdForNumber: '',
  deleted: true,
  difficultyLevel: {
    id: '',
    level: '',
    order: 0,
  },
  duration: 0,
  enabled: true,
  entityItemType: '',
  exploreListable: true,
  favCount: 0,
  featured: true,
  id: '',
  idByUser: true,
  labels: [],
  languages: [],
  locked: true,
  longDesc: '',
  maxDuration: 0,
  meditationIds: [],
  minDuration: 0,
  noOfEpisode: 0,
  noOfRating: 0,
  preRequisiteIds: [],
  primaryTags: [],
  prioritySetting: {},
  rating: 0,
  recommendedForKids: true,
  relativeCourses: [],
  reqToUnpublish: true,
  secondaryTags: [],
  sessions: [],
  shareLink: '',
  shortDesc: '',
  shortLink: '',
  slug: '',
  status: '',
  subscription: {
    id: '',
    name: '',
  },
  testimonials: [],
  title: '',
  type: '',
  welcomeMsg: '',
}

export const AGREEMENT_OBJECT = {
  userId: '',
  ipAddress: '',
  agreementId: '',
  accepted: false,
  mandatory: false,
}

const termsObject = {
  apiParam: 'article',
  id: 'terms',
  enabled: true,
  deleted: true,
  idByUser: true,
  title: 'Service Terms',
  shortDesc: 'Sample description',
  coverImage: 'MEDIA-647037d6361345b6abcac64b493664c0',
  status: 'draft',
  noOfEpisode: 0,
  subscription: {},
  featured: true,
  approved: false,
  rating: 0,
  noOfRating: 0,
  duration: 0,
  avgDuration: 0,
  minDuration: 0,
  maxDuration: 0,
  difficultyLevel: {
    order: 0,
  },
  publishAt: '2023-08-24 17:14',
  favCount: 0,
  courseType: 'audio',
  allowPreview: true,
  locked: true,
  reqToUnpublish: true,
  availableForPlan: false,
  exploreListable: true,
  recommendedForKids: true,
  content:
    '<p>1. ACCEPTANCE OF TERMS</p>\n<p>By accessing and using [Your Website/Service], you agree to comply with and be bound by the following Terms of Service. If you do not agree to these terms, please do not use the service.</p>\n<p></p>\n<p>2. DESCRIPTION OF SERVICE</p>\n<p>[Your Company Name] ("Company") provides [brief description of the service or website]. The Company reserves the right to change or discontinue the service, with or without notice.</p>\n<p></p>\n<p>3. USER REGISTRATION</p>\n<p>You may be required to register an account with us to access certain features of the service. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.</p>\n<p></p>\n<p>4. USER CONDUCT</p>\n<p>You agree not to use the service for any unlawful or prohibited purpose. This includes not using the service to:</p>\n<p></p>\n<p>&nbsp;&nbsp;&nbsp;a. Violate any applicable laws or regulations.</p>\n<p>&nbsp;&nbsp;&nbsp;b. Infringe upon any intellectual property rights.</p>\n<p>&nbsp;&nbsp;&nbsp;c. Distribute harmful software or engage in hacking.</p>\n<p>&nbsp;&nbsp;&nbsp;d. Transmit any unsolicited advertising or spam.</p>\n<p></p>\n<p>5. CONTENT</p>\n<p>a. Ownership: All content provided by the Company, including text, graphics, and other materials, is the property of the Company.</p>\n<p>b. User-Generated Content: By submitting any content to the service, you grant the Company a non-exclusive, royalty-free, worldwide license to use, distribute, and display the content in connection with the service.</p>\n<p>c. Removal of Content: The Company reserves the right to remove any content that violates these terms.</p>\n<p></p>\n<p>6. PRIVACY POLICY</p>\n<p>Please review our Privacy Policy [link to Privacy Policy] to understand how we collect, use, and protect your personal information.</p>\n<p></p>\n<p>7. DISCLAIMER OF WARRANTIES</p>\n<p>The service is provided "as is" without any warranties, express or implied. The Company does not guarantee that the service will be error-free, secure, or continuously available.</p>\n<p></p>\n<p>8. LIMITATION OF LIABILITY</p>\n<p>The Company and its affiliates are not liable for any direct, indirect, special, incidental, or consequential damages arising out of the use of the service or the inability to use it.</p>\n<p></p>\n<p>9. INDEMNIFICATION</p>\n<p>You agree to indemnify and hold the Company and its employees, agents, and partners harmless from any claim or demand, including reasonable attorney\'s fees, made by any third party due to your use of the service.</p>\n<p></p>\n<p>10. GOVERNING LAW</p>\n<p>These terms are governed by and construed in accordance with the laws of [Your State/Country].</p>\n<p></p>\n<p>11. CHANGES TO TERMS</p>\n<p>The Company reserves the right to change or modify these terms at any time. Your continued use of the service following the posting of any changes constitutes your acceptance of those changes.</p>\n',
}

export const LEGAL_POLICIES_LIST = [
  {
    ...LEGAL_OBJECT,
    ...termsObject,
    id: 'terms-1',
    title: 'Service Terms 1 very very long title',
    createdTime: '2023-08-20 20:14',
  },
  {
    ...LEGAL_OBJECT,
    ...termsObject,
    signed: true,
    id: 'terms-4',
    title: 'Service Terms 4',
    createdTime: '2023-08-24 17:14',
  },
  {
    ...LEGAL_OBJECT,
    ...termsObject,
    id: 'terms-2',
    title: 'Service Term 2',
    createdTime: '2023-08-24 17:14',
  },

  {
    ...LEGAL_OBJECT,
    ...termsObject,
    id: 'terms-3',
    title: 'Service Terms 3',
    createdTime: '2023-08-26 21:00',
  },
]

export async function getLegalPolicies() {
  const response = await getMPData('/api/secure/teacher/user-agreement/list')
  if (response.status === 200) {
    return response.data || []
  }
  return []
}

export async function getSingleLegalPolicy(id) {
  const response = await getMPDataWithParams(`/api/secure/teacher/user-agreement`, { id: id })
  if (response.status === 200) {
    return response.data
  }
  return null
}

export async function agreeTheAgreement(object) {
  const response = await postMPDataWithoutParams('/api/secure/teacher/user-agreement/sign', object)
  if (response.status === 200) {
    return response.data
  } else {
    toast.error('Something went wrong. Could not sign the agreement.')
    return null
  }
}

export const getClientIpAddress = async () => {
  try {
    const response = await fetch('https://ipapi.co/json/')
    const data = await response.json()
    const clientIp = data.ip
    return clientIp
  } catch (error) {
    console.error('Error getting client IP:', error)
  }
}
